import { FIELD_VALIDATION_ERROR } from '../../../../../../../../../controllers/issue-adjustments/utils/errors/constants';
import { mapFieldPropertyToApiMethod } from '../../../../../../../../../controllers/issue-adjustments/utils/map-field-property-to-api-method';
import { VALID_RESULT } from './constants';
var prepareValidationResultByBooleanValue = function prepareValidationResultByBooleanValue(_ref) {
  var validationResult = _ref.validationResult,
    fieldId = _ref.fieldId,
    fieldType = _ref.fieldType,
    propertyName = _ref.propertyName;
  if (validationResult === false) {
    return {
      isValid: false,
      error: {
        type: FIELD_VALIDATION_ERROR,
        method: mapFieldPropertyToApiMethod(propertyName),
        fieldId: fieldId,
        fieldType: fieldType
      }
    };
  }
  return VALID_RESULT;
};
var prepareValidationResultByExtendedValue = function prepareValidationResultByExtendedValue(_ref2) {
  var validationResult = _ref2.validationResult,
    fieldId = _ref2.fieldId,
    fieldType = _ref2.fieldType;
  if (validationResult.isValid === false) {
    return {
      isValid: false,
      error: {
        type: FIELD_VALIDATION_ERROR,
        method: validationResult.error.method,
        message: validationResult.error.message,
        fieldId: fieldId,
        fieldType: fieldType
      }
    };
  }
  return VALID_RESULT;
};
export var prepareValidationResult = function prepareValidationResult(_ref3) {
  var validationResult = _ref3.validationResult,
    fieldId = _ref3.fieldId,
    fieldType = _ref3.fieldType,
    propertyName = _ref3.propertyName;
  // We will remove the boolean check and old method after changing all validators to return objects
  if (typeof validationResult === 'boolean') {
    return prepareValidationResultByBooleanValue({
      validationResult: validationResult,
      fieldId: fieldId,
      fieldType: fieldType,
      propertyName: propertyName
    });
  }
  return prepareValidationResultByExtendedValue({
    validationResult: validationResult,
    fieldId: fieldId,
    fieldType: fieldType
  });
};
export var filterInvalidResults = function filterInvalidResults(validationResults) {
  return validationResults.reduce(function (acc, result) {
    if (result.isValid === false) {
      acc.push(result);
    }
    return acc;
  }, []);
};
export var isFieldPropertyName = function isFieldPropertyName(fieldFromIframe, propertyName) {
  return Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName);
};